module.exports = "<div class=\"sections-map__menu__text\">Секция</div>\r\n<% response.getSectionsCoordinates().forEach(function(item) { %>\r\n<a href=\"\"\r\n   class=\"sections-map__menu__number <%- response.getSectionName() == item.getNumber() ? 'active' : '' %> js-get-section\"\r\n   data-housing-code=\"<%- response.getHousingCode() %>\"\r\n   data-housing-id=\"<%- response.getHousingId() %>\"\r\n   data-section=\"<%- item.getId() %>\">№<%-item.getNumber()%></a>\r\n<% }) %>\r\n"


//////////////////
// WEBPACK FOOTER
// ./js/components/SectionsMapMenu/SectionsMapMenu.ejs
// module id = 232
// module chunks = 0